import React, { Component } from 'react';
import { Modal } from './Modal';
import { PrismButton } from './PrismButton';
import './ShoutoutNotFoundModal.scss';

class ShoutoutNotFoundModal extends Component {


  render() {
    const { showError, onClose } = this.props;
    return (
      <Modal header="Error" showModal={showError} closeModal={onClose} width="480px">
        <div className="error-modal-body">
          <div className="message-text">The Shoutout you are looking for could not be found</div>
          <PrismButton onClick={onClose} className="okay-button">OK</PrismButton>
        </div>
      </Modal>
    );

  }
}

export default ShoutoutNotFoundModal;


// WEBPACK FOOTER //
// ./src/components/ShoutoutNotFoundModal.js